jQuery = require('jquery');

var templateUrl = $('#TemplateUrl').attr('data-template-url');

$(function(){
//サイドナビゲーション
	var SideNavigation = require('./module/side_navigation.js');
	var sideNavigation = new SideNavigation('.side-navigation,.side-navigation-bg');

//アンカースクロール
	require('./module/anchor_scroll.js');

//ポップアップ
	require('./module/popup.js');

//ありえないカウンター
	var Count = require('./module/count.js');
	var cont = new Count('.arienai.count',templateUrl);

	//video
	var PlayVideo = require('./module/play_video.js');
	new PlayVideo();

	//navがはみ出したらスクロールするように高さ入れる
	adjustSideNav();
	$(window).on('resize', adjustSideNav);
	function adjustSideNav(){
		$('.side-navigation-open').css({
			height: window.innerHeight
		});
	}
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/source/pc/js/common.js
 ** module id = 0
 ** module chunks = 5
 **/